import { cx } from '@linaria/core';
import { PM2DisplayProvider } from '@pm2/store';
import { defaultPm2PrintChunkClassName } from '@provider/print';
import { units } from '@ui/css';
import { printContainerCls } from './grid.style.js';
import { printGridComponentColumn } from './printer.to-jsx.js';
import { jsx } from 'react/jsx-runtime';

const printGridComponentPaper = (node, context) => {
  const gridSize = node.children.map(it => it.meta.size).reduce((acc, curr) => acc + curr, 0);
  return [{
    containerClassName: cx(defaultPm2PrintChunkClassName, printContainerCls),
    columnGap: units.px(25),
    columns: node.children.map(it => {
      return {
        styles: {
          width: it.meta.size / gridSize * 100 + "%"
        },
        content: /*#__PURE__*/jsx(PM2DisplayProvider, {
          inGrid: true,
          children: printGridComponentColumn(it, {
            ...context,
            parentPrinters: {}
          })
        })
      };
    })
  }];
};
const gridComponentPaperPrinters = {
  "grid-component": printGridComponentPaper
};

export { gridComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
